import { useState } from "react";
import "./Login.css";
import { supabase } from "../../Servicios/supabaseClient";
import titulo from '../../Img/titulo.png';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';

export default function UpdatePassword() {
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!password || !confirmPassword) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos vacíos',
                text: 'Por favor, completa ambos campos de contraseña.',
                confirmButtonColor: '#f39c12'
            });
            return;
        }

        if (password !== confirmPassword) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Las contraseñas no coinciden.',
                confirmButtonColor: '#d33'
            });
            return;
        }

        setLoading(true);
        try {
            const { error } = await supabase.auth.updateUser({ password: password });

            if (error) throw error;

            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Contraseña actualizada correctamente',
                confirmButtonColor: '#3085d6'
            }).then(() => {
                navigate("/dashboard");
            });

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "Error actualizando: " + error.message,
                confirmButtonColor: '#d33'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginPage">
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <ClipLoader color="#ffffff" size={50} />
                </div>
            )}
            <div className="loginContainer">
                <img src={titulo} style={{ width: "100%" }} alt="QuantumNodo" />
                <p className="loginSubtitle" style={{ margin: "0.5rem" }}>Actualizar Contraseña</p>

                <form className="loginForm" onSubmit={handleUpdate}>
                    <div className="inputGroup">
                        <label htmlFor="password" className="inputLabel">Nueva Contraseña</label>
                        <input
                            type="password"
                            id="password"
                            className="inputField"
                            placeholder="Nueva contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className="inputGroup">
                        <label htmlFor="confirmPassword" className="inputLabel">Confirmar Contraseña</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            className="inputField"
                            placeholder="Repite la contraseña"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>

                    <button type="submit" className="loginBtn">Actualizar</button>
                </form>
            </div>
        </div>
    );
}
